<template>
  <Flex direction="column">
    <BaseCard gray>
      <Flex direction="column">
        <BaseRadio
          v-model="shareSetting"
          :label="$t('giftcard_widget.settings.share')"
          :options="[
            {
              value: ShareSettingsType.LINK,
              label: $t('promote.booking_widget.link_view')
            },
            {
              value: ShareSettingsType.BUTTON,
              label: $t('promote.booking_widget.button_view')
            },
            {
              value: ShareSettingsType.WIDGET,
              label: $t('promote.booking_widget.widget_view')
            }
          ]"
          v-test="'giftcard-setting-shareMethod'"
        />

        <div v-if="shareSetting === ShareSettingsType.WIDGET">
          <Flex direction="column">
            <BaseRadio
              v-model="formData.settings.bookingWidget.autoWidth"
              :label="$t('promote.booking_widget.settings.widget.size')"
              :options="widthSizeOptions"
              v-test="'booking-settings-autoWidth'"
            />
            <BaseGrid container>
              <BaseGrid
                :size="formData.settings.bookingWidget.autoWidth ? 12 : 6"
                :sSize="12"
              >
                <BaseInput
                  v-model="formData.settings.bookingWidget.height"
                  :label="$t('promote.booking_widget.settings.widget.height')"
                  type="number"
                />
              </BaseGrid>
              <BaseGrid
                v-if="!formData.settings.bookingWidget.autoWidth"
                :size="6"
                :sSize="12"
              >
                <BaseInput
                  v-model="formData.settings.bookingWidget.width"
                  :label="$t('promote.booking_widget.settings.widget.width')"
                  type="number"
                />
              </BaseGrid>
            </BaseGrid>
          </Flex>
        </div>
        <div v-else-if="shareSetting === ShareSettingsType.BUTTON">
          <BaseRadio
            v-model="formData.settings.bookingWidget.position"
            :label="$t('promote.booking_widget.settings.button.position')"
            :options="buttonPositionOptions"
            v-test="'giftcard-setting-buttonPosition'"
          />
        </div>
      </Flex>
    </BaseCard>

    <BaseCard
      v-if="shareSetting === ShareSettingsType.LINK"
      gray
    >
      <BaseInputLabel :text="$t('promote.booking_widget.link')" />
      <BaseCodeField
        :code="widgetUrl"
        :loading="loadingMicroSite"
        buttonType="inverted"
        multiline
        v-test="'widget-styling-link'"
      />
    </BaseCard>
    <Snippet
      v-if="shareSetting !== ShareSettingsType.LINK"
      gray
    />
  </Flex>
</template>

<script lang="ts">
export default {
  name: 'SharingSettings',
};
</script>

<script
  setup
  lang="ts"
>
import { useStorage } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import { useBookingSettingsOptions } from '@/modules/admin/online-bookings/input-options';
import { useMicroSiteStore } from '@/stores/micro-site';
import Snippet from './Snippet.vue';

const formData = inject<any>('giftcardSettingsData');

const { giftcardWidgetUrl: widgetUrl, loading: loadingMicroSite } = storeToRefs(
  useMicroSiteStore(),
);
const { buttonPositionOptions, widthSizeOptions } = useBookingSettingsOptions();

enum ShareSettingsType {
  LINK = 'link',
  BUTTON = 'button',
  WIDGET = 'widget',
}

const shareSettings = Object.freeze(ShareSettingsType);

const shareSetting = useStorage('share-setting', shareSettings.LINK);
watch(shareSetting, (newValue) => {
  formData.settings.bookingWidget.inline = newValue !== shareSettings.BUTTON;
});

if (!formData.settings.bookingWidget.inline) {
  shareSetting.value = shareSettings.BUTTON;
}
</script>
